import { useMemo, useState } from "react";
import { editorials } from "@/mocks/editorial";
import SectionHeading from "./SectionHeading";

const categories = ["全部", "院线前瞻", "影评深读", "观影指南", "冷门拾遗"];

export default function Editorial() {
  const [cat, setCat] = useState("全部");
  const list = useMemo(() => (cat === "全部" ? editorials : editorials.filter((e) => e.category === cat)), [cat]);
  const lead = list[0];
  const rest = list.slice(1);

  return (
    <section id="review" className="section-pad scroll-mt-20 bg-background-50">
      <div className="container-x">
        <SectionHeading
          eyebrow="影评专栏"
          title="不止看电影，也读电影"
          desc="编辑部的前瞻、影评与指南，帮你先一步读懂银幕背后的门道，也给出更聪明的观影选择。"
        />

        <div className="mt-7 flex flex-wrap items-center gap-2" role="tablist" aria-label="专栏分类">
          {categories.map((c) => (
            <button
              key={c}
              type="button"
              role="tab"
              aria-selected={cat === c}
              onClick={() => setCat(c)}
              className={
                "rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors " +
                (cat === c
                  ? "bg-accent-500 font-semibold text-foreground-950"
                  : "border border-background-300 text-foreground-700 hover:border-accent-400 hover:text-accent-700")
              }
            >
              {c}
            </button>
          ))}
        </div>

        {list.length > 0 ? (
          <div className="mt-8 grid gap-6 lg:grid-cols-[1.4fr_1fr]">
            {/* 头条 */}
            <article className="group flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-100 transition-transform duration-300 hover:-translate-y-1">
              <div className="relative overflow-hidden">
                <img src={lead.image} alt={lead.title} className="aspect-[16/9] w-full object-cover object-center transition-transform duration-500 group-hover:scale-105" />
                <span className="absolute left-4 top-4 inline-flex items-center gap-1 rounded-full bg-primary-600 px-3 py-1 text-xs font-semibold text-white">
                  {lead.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6 md:p-7">
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1"><i className="ri-calendar-line" aria-hidden="true"></i>{lead.date}</span>
                  <span className="inline-flex items-center gap-1"><i className="ri-time-line" aria-hidden="true"></i>{lead.readTime}</span>
                </div>
                <h3 className="mt-3 font-heading text-xl font-black leading-snug text-foreground-950 group-hover:text-primary-700 md:text-2xl">
                  {lead.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{lead.summary}</p>
              </div>
            </article>

            {/* 侧栏列表 */}
            <div className="flex flex-col gap-4">
              {rest.map((e) => (
                <article key={e.id} className="group flex cursor-pointer gap-4 rounded-2xl border border-background-200 bg-background-100 p-3 transition-colors hover:border-accent-300">
                  <div className="hidden w-28 shrink-0 overflow-hidden rounded-xl sm:block md:w-32">
                    <img src={e.image} alt={e.title} className="aspect-[3/2] h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105" />
                  </div>
                  <div className="flex min-w-0 flex-1 flex-col py-0.5">
                    <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-accent-700">
                      <i className="ri-price-tag-3-line" aria-hidden="true"></i>
                      {e.category}
                    </span>
                    <h4 className="mt-1 line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-base">
                      {e.title}
                    </h4>
                    <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">{e.summary}</p>
                    <div className="mt-auto flex items-center gap-2 pt-2 text-[11px] text-foreground-500">
                      <span>{e.date}</span>
                      <span>·</span>
                      <span>{e.readTime}</span>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        ) : (
          <p className="mt-8 rounded-2xl border border-dashed border-background-300 p-10 text-center text-sm text-foreground-500">
            该分类暂无内容，稍后回来看看吧。
          </p>
        )}
      </div>
    </section>
  );
}